<form class="full-size quick-search-section" [formGroup]="searchForm" (ngSubmit)="execSearch()">
  <div class="quick-search-input">
    <input kendoTextBox class="full-size" formControlName="searchText" [placeholder]="'Rechercher une formation ...'" />
  </div>
  <button kendoButton class="colored-text quick-search-bt" [primary]="true" [icon]="'search'"></button>
</form>
